import React from 'react';
import { FaListUl, FaThLarge, FaCalendarCheck, FaUsers } from 'react-icons/fa';

const steps = [
  {
    step: 'Step 01',
    icon: <FaListUl />,
    title: 'Understanding the Problem',
    points: [
      'Ask questions about your condition',
      'Learn about PKD progression',
      'Understand your specific PKD type',
    ],
  },
  {
    step: 'Step 02',
    icon: <FaThLarge />,
    title: 'Control What You Can',
    points: [
      'Blood pressure control is the top priority',
      'Stay well hydrated as recommended',
      'Ensure medication safety for kidneys',
    ],
  },
  {
    step: 'Step 03',
    icon: <FaCalendarCheck />,
    title: 'Plan for the future',
    points: [
      'Keep regular medical appointments',
      'Stay informed about new treatments',
      'Consider genetic counseling for family',
    ],
  },
  {
    step: 'Step 04',
    icon: <FaUsers />,
    title: 'Build your Care Team',
    points: [
      'Family and community support network',
      'Primary care physician for overall health',
      'Registered dietitian for nutrition guidance',
    ],
  },
];

const ProblemSolving = () => {
  return (
    <section className="section problem-solving-section" style={{ backgroundColor: '#fff' }}>
      <div className="container">
        <h2 className="section-title">Problem-Solving Approach to PKD</h2>
        <div className="problem-solving-grid">
          {steps.map((item, index) => (
            <div className={`problem-solving-item item-${index + 1}`} key={index}>
              <div className="item-header">
                <div className="step-label">{item.step}</div>
                <div className="step-icon">{item.icon}</div>
              </div>
              <div className="item-content">
                <h4>{item.title}</h4>
                <ul>
                  {item.points.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProblemSolving;